
import React, {useEffect, useState} from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import PropTypes from 'prop-types';
import './styles/ProductPageFooter.scss';
import ReaderAppsPicker from './ReaderAppsPicker';

export default function ProductPageFooter(props) {

    const [format, setFormat] = useState('');
    const [deviceType, setDeviceType] = useState('');
    const [platform, setPlatform] = useState('');

    const [showApps, setShowApps] = useState(false);

    const handleReset = () => {
        setFormat('');
        setDeviceType('');
        setPlatform('');
    };

    useEffect(() => {
        let empty = 0;
       
        if (format === "") {
            empty += 1;
        }

        if (deviceType === "") {
            empty += 1;
        }

        if (platform === "") {
            empty += 1;
        }

        if (empty === 0) {
            setShowApps(true);
        } else {
            setShowApps(false);
        }
 
    }, [format, deviceType, platform, showApps]);

    return (
        <div className="product-footer">
            <Container>
                {
                    props.showReaderAppsRow ? 
                    <Row className="reader-row" ref={props.myRef}>
                        <Col lg={6} md={4}>
                            <p className="f17 fw-bold">Help Center</p>
                            <ul>
                                <li><a 
                                    href="#" 
                                    className="f14" 
                                    onClick={(e) => {
                                        e.preventDefault();
                                        props.onRefundPolicyShow();
                                        return false;
                                    }}
                                >Refund Policy</a></li>
                                {/* <li><a href="" className="f14">Customer Support</a></li>
                                <li><a href="" className="f14">Leave A Review</a></li> */}
                            </ul>
                        </Col>
                        <Col lg={6} md={8} className="reader-apps">
                           <ReaderAppsPicker />
                        </Col>
                    </Row> : ""
                }
                <Row className="prod-pow">
                    <Col className="d-flex justify-content-center align-items-center">
                        <p className="f14">Secure ebook fulfillment and store powered by</p>
                        <img src="/images/logo.png" alt=""/>  
                    </Col>
                </Row>
            </Container>
        </div>
    );
}
ProductPageFooter.propTypes = {
    myRef: PropTypes.any,
    showReaderAppsRow : PropTypes.bool,
    onRefundPolicyShow : PropTypes.func
};
    